<app-content-container 
  title="Manage Staff"
  [contentNavOptions]="contentNavOptions"
  (navClicked)="onNavClicked($event)"
>
  <div >
    <app-staff-list *ngIf="selectedTab === 'Staff List'"></app-staff-list>
    <app-reassign-staff
      *ngIf="selectedTab === 'Reassign Staff'"
    ></app-reassign-staff>
  </div>
</app-content-container>
